import {Component, computed, inject, input, signal} from "@angular/core";
import {LabelledContainerComponent} from "@common/ui/labelled-container/labelled-container.component";
import {Translations} from "@translations";
import {AutomaticRecordingSessionDialogStore} from "../../store/automatic-recording-session-dialog.store";
import {SharedModule} from "../../../../../../../shared/shared.module";
import {ListComponent} from "../../../../../../../shared/shared-components/list/list.component";
import {ListItemComponent} from "@common/ui/list-item/list-item.component";
import {FetchDataType} from "@models";
import {StopPropagationDirective} from "@common/pipes/stop-propagation.directive";
import {explicitEffect} from "ngxtension/explicit-effect";

@Component({
	selector: "sim-automatic-recording-session-step1",
	imports: [LabelledContainerComponent, SharedModule, ListComponent, ListItemComponent, StopPropagationDirective],
	templateUrl: "./automatic-recording-session-step1.component.html",
	styleUrl: "./automatic-recording-session-step1.component.scss",
})
export class AutomaticRecordingSessionStep1Component {
	protected readonly T = Translations;
	protected readonly FetchDataType = FetchDataType;

	protected readonly store = inject(AutomaticRecordingSessionDialogStore);

	public readonly eventStartDate = input.required<Date>();
	public readonly eventEndDate = input.required<Date>();

	protected readonly excludeRoomIds = computed<string[]>(
		() =>
			this.store
				.stations()
				.map((s) => s.trainingRoom?.id)
				.filter((s) => s !== undefined) ?? [],
	);
	protected readonly excludeScenarioIds = computed<string[]>(
		() =>
			this.store
				.stations()
				.map((s) => s.scenario?.id)
				.filter((s) => s !== undefined) ?? [],
	);
	protected readonly isFormCooldown = signal<boolean>(false);

	// This effect is needed because the form control input of the autocomplete does not support setting a new instance
	// from the outside. It serves as a 'remount' mechanism
	readonly #formCooldownEffect = explicitEffect([this.store.activeStationForm], (_, onCleanup) => {
		this.isFormCooldown.set(true);
		const timeout = setTimeout(() => this.isFormCooldown.set(false), 300);

		onCleanup(() => clearTimeout(timeout));
	});
}
